import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Company} from '../../../models/company';
import {getCompanySubscriptionMeta} from '../shared/company-subscription';

@Component({
    selector: 'app-companies-settings-header',
    templateUrl: './companies-settings-header.component.html',
    styleUrls: ['./companies-settings-header.component.scss']
})
export class CompaniesSettingsHeaderComponent {
    @Input() company: Company = new Company();
    @Input() isSuperAdmin = false;
    @Input() provinces: { id: string; name: string }[] = [];

    @Output() logoChange = new EventEmitter<Event>();
    @Output() copyId = new EventEmitter<string>();

    get subscriptionMeta() {
        return getCompanySubscriptionMeta(this.company);
    }

    get provinceName(): string {
        const code = (this.company.province ?? '').trim();
        if (!code) {
            return '';
        }
        return this.provinces.find((province) => province.id === code)?.name ?? code;
    }

    get locationLine(): string {
        const parts = [this.company.city, this.provinceName].filter((part) => !!part);
        return parts.join(', ');
    }

    get fiscalLine(): string {
        const parts: string[] = [];
        if (this.company.vat) {
            parts.push(`P. IVA ${this.company.vat}`);
        }
        if (this.company.fiscalCode) {
            parts.push(`CF ${this.company.fiscalCode}`);
        }
        return parts.join(' · ');
    }

    onCopyId(): void {
        if (this.company.id) {
            this.copyId.emit(this.company.id);
        }
    }
}
